export interface GallerySlide {
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Firefighter equipment diagrams',
  'PPE component references',
  'SCBA awareness illustrations',
  'Tool identification',
  'Apparatus references',
  'Hose system diagrams',
  'Water supply layouts',
  'Nozzle identification',
  'Fireground operational maps',
  'Ladder illustrations',
  'Building access diagrams',
  'Ventilation concept illustrations',
  'Structural building cutaways',
  'Search and rescue floor plans',
  'Team coordination diagrams',
  'Rescue priority scenarios',
  'Fireground hazard maps',
  'Communication exercises',
  'Accountability boards',
  'Vehicle incident illustrations',
  'Technical incident references',
  'Common-error comparisons',
  'Instructor teaching sheets',
  'Training scenario boards',
  'Student assessment tools',
  'Quick-reference cards',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/eXumEf6VsEiKW95rU7U6WK/Captura_de_pantalla_2026-10-18_230739.png',
    alt: 'Apartment building full scenario board: multi-unit search floor plan with orientation, search priority, communication, accountability and hazard awareness questions',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/usFaAN41X4yFxPWyVnitCj/Captura_de_pantalla_2026-10-18_230716.png',
    alt: 'The complete picture: full annotated training cutaway of a two-storey house with entry, fire area, smoke zone, victim location, team positions and exits',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2mT9wsEB2DdFpfndBgvhAL/Captura_de_pantalla_2026-10-18_230643.png',
    alt: 'Know where you are operating: fireground zones reference showing hazard, operational, access and support areas',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iof6Nuyyoh2Dweq2mMCETC/Captura_de_pantalla_2026-10-18_230608.png',
    alt: 'One incident, multiple demands: rescue priority board with three victim locations in a house cutaway and student analysis panels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hYDXYraFuSA5goMcBsstML/Captura_de_pantalla_2026-10-18_230537.png',
    alt: 'Fast does not mean random: search coverage versus speed comparison on floor plans, 60% versus 100% coverage',
  },
]
